function numberToWords(num) {
  const below20 = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
  const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
  const thousands = ["", "thousand", "lakh", "crore"];

  function helper(n) {
    if (n === 0) return "";
    if (n < 20) return below20[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + below20[n % 10] : "");
    return below20[Math.floor(n / 100)] + " hundred" + (n % 100 ? " " + helper(n % 100) : "");
  }

  let result = "";
  let i = 0;
  while (num > 0) {
    if (num % 1000 !== 0) {
      result = helper(num % 1000) + (thousands[i] ? " " + thousands[i] : "") + (result ? " " + result : "");
    }
    num = Math.floor(num / 1000);
    i++;
  }

  return result.trim();
}

function formatPKR(amount) {
  if (!amount || isNaN(amount)) return "0";

  const absAmount = Math.abs(amount);
  let result = "";

  if (absAmount >= 10000000) {
    // Crore
    result = `${Math.floor(amount / 10000000)} crore`;
  } else if (absAmount >= 100000) {
    // Lakh
    const lakh = Math.floor(amount / 100000);
    const remaining = Math.floor(amount % 100000);
    result = `${numberToWords(lakh)} lakh ${remaining > 0 ? numberToWords(remaining) : ''}`.trim();
  } else if (absAmount >= 1000) {
    // Thousand
    const thousand = Math.floor(amount / 1000);
    const remaining = Math.floor(amount % 1000);
    result = `${numberToWords(thousand)} thousand ${remaining > 0 ? numberToWords(remaining) : ''}`.trim();
  } else {
    result = numberToWords(amount);
  }

  return amount < 0 ? `- ${result}` : result;
}

export default formatPKR;